// Initialize site wide scripts

import {scrollToElement} from "./helpers/scrolling/scrolling";

// Required for backwards compatibility with existing scripts
window.scrollToElementNative = scrollToElement;
